import day from "dayjs";
import { Form, Link } from "react-router";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { FaLocationArrow, FaBriefcase, FaCalendarAlt } from "react-icons/fa";

import type { IJob } from "@/helpers/interfaces";

import { JobWrapper } from "@/components/wrappers";

import { JobInfo } from ".";

day.extend(advancedFormat);

const Job = (props: IJob) => {
  const { _id, position, company, jobStatus, jobType, jobLocation, createdAt } = props;
  const date = day(createdAt).format("MMM Do, YYYY");

  return (
    <JobWrapper>
      <header>
        <div className="main-icon">{company.charAt(0)}</div>
        <div className="info">
          <h5>{position}</h5>
          <p>{company}</p>
        </div>
      </header>
      <div className="content">
        <div className="content-center">
          <JobInfo icon={<FaLocationArrow />} text={jobLocation} />
          <JobInfo icon={<FaCalendarAlt />} text={date} />
          <JobInfo icon={<FaBriefcase />} text={jobType} />
          <div className={`status ${jobStatus}`}>{jobStatus}</div>
        </div>

        <footer className="actions">
          <Link className="btn edit-btn" to={`../edit-job/${_id}`}>
            Edit
          </Link>
          <Form method="POST" action={`../delete-job/${_id}`}>
            <button type="submit" className="btn delete-btn">
              Delete
            </button>
          </Form>
        </footer>
      </div>
    </JobWrapper>
  );
};
export default Job;
